import { RESUME_SHELL_PREFIX } from '@/routes/paths';

/**
 * O resumo do produto é um shell (cabeçalho + sidebar) cujos itens são rotas
 * aninhadas. Para a porta de transição, trocar de item ali não é trocar de tela:
 * o shell fica, e quem carrega a área central é o `Suspense` local dele. Sem
 * este recorte, cada clique na sidebar escondia o shell inteiro atrás do
 * loading de tela inteira.
 *
 * Vive aqui, e não em `sections/.../productResumePathUtils`, para o layout não
 * depender de uma seção.
 */
const RESUME_SHELL_SCOPE = new RegExp(`^(.*${RESUME_SHELL_PREFIX}[^/]+)(?:/|$)`);

export function getRouteTransitionScope(pathname = '') {
  const match = RESUME_SHELL_SCOPE.exec(pathname);

  return match ? match[1] : pathname;
}
